// Partner login — request a magic-link email.
// No password. Email + click-the-link. Token validates partner identity.
import React, { useState } from "react";
import axios from "axios";
import { CheckCircle2, Mail } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function PartnerLogin() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email || loading) return;
    setLoading(true);
    try {
      await axios.post(`${API}/partner/login-request`, { email });
      setSent(true);
    } catch (err) {
      // Backend returns 200 even when email is unknown (anti-enumeration)
      setSent(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[70vh] flex items-center justify-center px-5 py-12">
      <div className="w-full max-w-md pg-card p-7" data-testid="partner-login-card">
        <div className="pg-mono text-[10px] uppercase tracking-[0.22em] text-[#5EEAD4] mb-2">
          // Partner Portal
        </div>
        <h1 className="text-[#F7FAFC] text-3xl pg-heading mb-1" style={{ fontFamily: "'Rajdhani'" }}>
          Sign in to your partner dashboard.
        </h1>
        <p className="text-[#9CA8B8] text-sm leading-relaxed mb-6">
          Enter the email registered with Peptigen Labs. We'll send you a secure sign-in link.
        </p>

        {sent ? (
          <div className="p-5 rounded-sm border border-[#A6FF00]/30 bg-[#A6FF00]/[0.06]" data-testid="partner-login-sent">
            <CheckCircle2 size={22} className="text-[#A6FF00] mb-2" />
            <div className="text-[#F7FAFC] font-semibold mb-1">Check your inbox.</div>
            <div className="text-[#9CA8B8] text-sm leading-[1.65]">
              If that email is associated with a Peptigen Labs partner account, a sign-in link has
              been sent. The link expires in 24 hours.
            </div>
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-4">
            <label className="block">
              <span className="pg-mono text-[10px] uppercase tracking-[0.18em] text-[#5EEAD4] mb-1 block">
                Partner Email
              </span>
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="you@yourcompany.co.uk"
                className="pg-input w-full text-[15px]"
                data-testid="partner-login-email"
              />
            </label>
            <button
              type="submit"
              disabled={loading}
              className="pg-btn-primary w-full inline-flex items-center justify-center gap-2 disabled:opacity-60"
              data-testid="partner-login-submit"
            >
              <Mail size={16} />
              {loading ? "Sending…" : "Send Sign-in Link"}
            </button>
          </form>
        )}

        <p className="mt-6 pt-5 border-t border-[#1E2A44] text-[#9CA8B8] text-[12px] leading-relaxed">
          Not a partner yet? Email{" "}
          <a href="mailto:info@peptigenlabs.co.uk" className="text-[#5EEAD4]">info@peptigenlabs.co.uk</a>
          {" "}to apply.
        </p>
      </div>
    </div>
  );
}
